module.exports = __webpack_public_path__ + "img/2-2.f867c301.svg";